module.exports = __webpack_public_path__ + "static/lash-lift-72512b6523c46cabe370975874ce3f22.jpg";